import React from "react";
import { FaClock, FaUser } from "react-icons/fa";
import { formatCurrency } from "../utils/displayHelpers";
import "./ServiceCard.css";

/**
 * One service, one tile. Used on every page that lists services to a customer.
 *
 * 180x120, adopted 2026-11-03 after the owner reviewed the shop page: name, price, duration, how many
 * professionals offer it (bottom left) and Book (bottom right). The thumbnail and the description were
 * removed — at this size they cost more than they give, and the description was the only
 * variable-length string in the body, which is what made rows refuse to line up.
 */
const ServiceCard = ({
  service,
  professionalCount = 0,
  onSelect,
  ctaLabel = "Book",
  footnote = "",
}) => {
  const duration = service?.longestDuration || service?.durationMinutes;
  const price =
    service?.price !== null && service?.price !== undefined
      ? service.price
      : service?.lowestPrice;
  const hasPrice = price !== null && price !== undefined && price !== "";

  return (
    <button
      type="button"
      className="service-tile"
      onClick={() => onSelect?.(service)}
      title={service?.name}
    >
      <span className="service-tile-name">{service?.name}</span>

      <span className="service-tile-meta">
        {hasPrice && (
          <span className="service-tile-price">{formatCurrency(price)}</span>
        )}
        {duration > 0 && (
          <span className="service-tile-dur">
            <FaClock size={11} aria-hidden="true" />
            {duration}m
          </span>
        )}
      </span>

      {/* Optional one-line context (search results: which shop, and where). */}
      {footnote && <span className="service-tile-footnote">{footnote}</span>}

      <span className="service-tile-foot">
        {professionalCount > 0 && (
          <span
            className="service-tile-badge"
            title={`${professionalCount} professional${
              professionalCount > 1 ? "s" : ""
            } offer this service`}
          >
            <FaUser size={9} aria-hidden="true" />
            {professionalCount}
          </span>
        )}
        <span className="service-tile-cta">{ctaLabel}</span>
      </span>
    </button>
  );
};

export default ServiceCard;